// Engine feature flags.
//
// DEPLOYMENT_LAYER gates 실전 기록 — the record surface, its sheets, the
// day-of card, the beat, and the review ceremony's 표현 예약하기.
//
// WHY IT IS OFF. The learning spine (map, hero, arc, review, return) is
// finished and reviewed; the deployment layer's MECHANIC is not settled
// (R4 Part B). Production carries zero engineDeployments today, so the
// record can still be redesigned freely. Ship it first and every design
// change becomes a migration against members' own sentences — the one kind
// of data we cannot regenerate. So the spine ships and this waits.
//
// Flipping this to true must be accompanied by deploying the
// engineDeployments block in firestore.rules, or every write fails.
// Reads an env var so the e2e can exercise BOTH states — the layer's own
// suite still runs under VUE_APP_DEPLOYMENT_LAYER=true, and a separate spec
// proves the off state is genuinely inert. Absent the var it is OFF, which
// is what every real build gets.
export const DEPLOYMENT_LAYER = process.env.VUE_APP_DEPLOYMENT_LAYER === 'true';

// REVIEW_BUTTON gates the review UI on the record card (the line under the
// sentence, the marks, 검토 중). Ruled 2026-09-04, corrected 2026-09-06: it
// ships in phase 1 behind Eddie's MANUAL reviews — the desk writes every
// review today. Only the MODEL waits for calibration (the fifty graded, the
// override rate accepted); until phase 4 it is invisible whatever this says.
// Flip it together with DEPLOYMENT_LAYER.
export const REVIEW_BUTTON = DEPLOYMENT_LAYER && process.env.VUE_APP_REVIEW_BUTTON === 'true';

// ENGINE_CUTOVER (2026-09-07) gates the one cutover change that alters what a
// member sees at a URL they already use: `/home` redirects to the engine home.
// Everything else in the cutover set (the 완료 derivation, the drill block on
// 수업, page-view logging from App.vue, the rank pill in the engine chrome,
// the 인증함 marker) is inert on the legacy surfaces and needs no flag. Off in
// every real build until GO 4.
export const ENGINE_CUTOVER = process.env.VUE_APP_ENGINE_CUTOVER === 'true';

export default { DEPLOYMENT_LAYER, REVIEW_BUTTON, ENGINE_CUTOVER };
